<template>
  <span title="Required field">
    (<font-awesome-icon :icon="['fas', 'asterisk']" size="sm" class="text-danger font-weight-bold"/>)
  </span>
</template>

<script>
export default {
  name: 'BaseRequiredField'
}
</script>

<style>
.text-required {
  color: #dd0000 !important;
}
.text-danger.font-weight-bold {
    font-size: 0.45rem!important;
    vertical-align: top;
    margin-top: 5px;
}
</style>
